import { Send, X } from 'lucide-react';
import DocumentUploader from './DocumentUploader';
import { getFileIcon } from './FileIcons';
import { useState } from 'react';

const ChatInput = ({ inputMessage, setInputMessage, handleSendMessage, isTyping, widgetSettings }) => {
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const [isFocused, setIsFocused] = useState(false);

  const handleSubmit = () => {
    if (inputMessage.trim() || selectedDocuments.length > 0) {
      handleSendMessage(selectedDocuments);
      setSelectedDocuments([]); // Limpa os documentos após enviar
    }
  };

  const removeDocument = (index) => {
    setSelectedDocuments(prev => prev.filter((_, i) => i !== index));
  };

  return (
    <div className="bg-gradient-to-t from-white to-gray-50/50 border-t-2 border-gray-100">
      {/* Lista de documentos anexados */}
      {selectedDocuments.length > 0 && (
        <div className="max-w-5xl mx-auto px-6 pt-4">
          <div className="flex flex-wrap gap-3">
            {selectedDocuments.map((doc, index) => (
              <div
                key={index}
                className="relative group flex items-center gap-3 bg-gradient-to-r from-indigo-50 to-blue-50 rounded-2xl p-3 pr-12 hover:from-indigo-100 hover:to-green-100 transition-all shadow-sm border border-indigo-200/50 transform hover:scale-[1.02]"
              >
                <div className="w-10 h-10 bg-white rounded-xl flex items-center justify-center shadow-sm">
                  <img
                    src={getFileIcon(doc?.mime_type)} 
                    alt="File icon" 
                    className="w-6 h-6 object-contain"
                  />
                </div>
                <span className="text-sm font-medium text-gray-700 max-w-[200px] truncate">
                  {doc?.file_name || doc?.file_url.split('/').pop()}
                </span>
                <button
                  onClick={() => removeDocument(index)}
                  className="absolute right-2 top-1/2 -translate-y-1/2 p-2 bg-white hover:bg-red-50 rounded-xl transition-all shadow-sm group-hover:shadow-md"
                >
                  <X className="w-4 h-4 text-gray-500 hover:text-red-500 transition-colors" />
                </button>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Input de mensagem aprimorado */}
      <div className="p-6">
        <div className="max-w-5xl mx-auto">
          <div className={`relative transition-all duration-300 ${isFocused ? 'transform scale-[1.01]' : ''}`}>
            <div className={`relative bg-white rounded-3xl shadow-xl transition-all duration-300 ${
              isFocused ? 'ring-4 ring-indigo-100 border-indigo-400' : 'border-gray-200'
            } border-2`}>
              <textarea
                className="w-full bg-transparent rounded-3xl px-6 py-4 pr-24 focus:outline-none resize-none text-base lg:text-lg text-gray-900 placeholder-gray-400"
                style={{ fontFamily: widgetSettings.font_primary || 'Inter' }}
                placeholder="Digite sua mensagem aqui..."
                rows="2"
                value={inputMessage}
                disabled={isTyping}
                onChange={(e) => setInputMessage(e.target.value)}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && !e.shiftKey) {
                    e.preventDefault();
                    handleSubmit();
                  }
                }}
              />
              
              {/* Botões de ação */}
              <div className="absolute right-3 bottom-3 flex items-center gap-2">
                {
                <div className="hover:opacity-100 transition-opacity">
                  <DocumentUploader 
                    onDocumentsChange={setSelectedDocuments} 
                    documents={selectedDocuments}
                  />
                </div>
                }
                
                {/* Botão de enviar */}
                <button
                  className={`p-3 rounded-2xl text-white font-semibold transition-all transform hover:scale-[1.05] active:scale-[0.95] shadow-lg hover:shadow-xl ${
                    inputMessage.trim() || selectedDocuments.length > 0
                      ? 'bg-gradient-to-r from-green-800 to-green-600 hover:from-green-700 hover:to-green-700'
                      : 'bg-gray-300 cursor-not-allowed'
                  }`}
                  onClick={handleSubmit}
                  disabled={isTyping || (!inputMessage.trim() && selectedDocuments.length === 0)}
                >
                  <Send className="w-5 h-5" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatInput;